export class CardTitleUtils {
    static async cleanYoutubeURL(url) {
        return url.replace(/&t=\d+s/, "");
    }
    static generateTitle(document, exludedUrls = undefined) {
        if (exludedUrls) {
            for (let i = 0; i < exludedUrls.length; i++) {
                if (document.location.href.includes(exludedUrls[i]))
                    return "";
            }
        }
        return document.title.replace(/^\(\d+\)\s/, "") || "";
    }
}
